import { Button } from 'antd';
import { Download, Plus, ShieldAlert } from 'lucide-react';
import { useState } from 'react';
import { Navigate } from 'react-router';
import { EmptyState } from '../../../shared/components/EmptyState';
import { TableSkeleton } from '../../../shared/components/TableSkeleton';
import { useRateCardList } from '../hooks/use-rate-card-list';
import { useRateCardPermissions } from '../hooks/use-rate-card-permissions';
import { rateLineTemplateUrl } from '../rate-cards.api';
import { buildRateCardColumns } from './build-rate-card-columns';
import { CreateRateCardDrawer } from './CreateRateCardDrawer';
import { RateCardsTable } from './RateCardsTable';

/** The cards themselves, with the actions that act on this list: the create drawer reloads it, so they sit here and not in the page header. */
export function RateCardsListTab() {
  const { state, list, isRefreshing, reload } = useRateCardList();
  const { canEdit } = useRateCardPermissions();
  const [drawerOpen, setDrawerOpen] = useState(false);

  if (state.status === 'forbidden') return <Navigate to="/" replace />;

  const columns = buildRateCardColumns({ list, canEdit, onDeactivated: reload });

  return (
    <>
      <p className="mb-4 text-muted">What each customer is charged per lane, and the standard card spot business falls back to.</p>
      <div className="mb-4 flex flex-wrap gap-2">
        <a href={rateLineTemplateUrl()}>
          <Button icon={<Download className="size-4" />}>Blank template</Button>
        </a>
        {canEdit && (
          <Button type="primary" icon={<Plus className="size-4" />} onClick={() => setDrawerOpen(true)}>
            Create rate card
          </Button>
        )}
      </div>
      {state.status === 'error' && (
        <EmptyState icon={ShieldAlert} title="Couldn't load rate cards" description="Something went wrong loading the rate cards. Try reloading the page." />
      )}
      {state.status === 'loading' && <TableSkeleton label="Loading rate cards" />}
      {state.status === 'loaded' && <RateCardsTable page={state.page} columns={columns} list={list} isRefreshing={isRefreshing} />}
      <CreateRateCardDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} onCreated={reload} />
    </>
  );
}
